module.exports = __webpack_public_path__ + "static/img/1-2.b7da210.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/1-2.png
// module id = miix
// module chunks = 0